import { render, staticRenderFns } from "./contractItems.vue?vue&type=template&id=5e8fcc7f"
import script from "./contractItems.vue?vue&type=script&lang=js"
export * from "./contractItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports